"use client";
import React, { useState } from "react";
import Link from "next/link";
import classes from "../header.module.css";

export default function MobileMenuItem({
  item,
  trans,
  locale = "vi",
  onClose,
}: {
  item: any;
  trans: any;
  locale?: string;
  onClose: () => void;
}) {
  const [open, setOpen] = useState(false);

  const getHref = (href: string) => {
    if (!href || href === "#") return "#";
    if (href.startsWith("http")) return href;
    const cleanHref = href.startsWith("/") ? href : `/${href}`;
    if (cleanHref.startsWith(`/${locale}/`) || cleanHref === `/${locale}`) {
      return cleanHref;
    }
    return `/${locale}${cleanHref}`;
  };

  if (!item.children) {
    return (
      <Link 
        href={getHref(item.href)} 
        scroll={false} 
        className={classes.mobileMenuTitle}
        onClick={onClose}
      >
        {item.label(trans)}
      </Link>
    );
  }

  return (
    <div className={classes.mobileMenuItem}>
      <div
        className={classes.mobileMenuTitle}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{item.label(trans)}</span>
        <span className={`${classes.arrow} ${open ? classes.open : ""}`}>▼</span>
      </div>
      <div className={`${classes.mobileSubMenu} ${open ? classes.open : ""}`}>
        {item.children.map((child: any) => (
          <Link
            key={child.href}
            href={getHref(child.href)}
            className={classes.mobileSubMenuItem}
            scroll={false}
            onClick={onClose}
          >
            {child.label(trans)}
          </Link>
        ))}
      </div>
    </div>
  );
}
